import React, { useState, useEffect, useRef } from 'react';
import styles from './HowItWorks.module.scss';

const stepsData = [
  {
    id: '01',
    title: 'Добавляйте доходы и расходы',
    desc: 'Вносите транзакции за пару секунд. Категории помогают быстро навести порядок в финансах и видеть, куда уходят деньги.',
    visual: (
      <div className={styles.visualMock}>
        <div className={styles.visualMock__header}>
          <div className={styles.visualMock__dot}></div>
          <div className={styles.visualMock__dot}></div>
          <div className={styles.visualMock__dot}></div>
        </div>
        <div className={styles.visualMock__body}>
          <div className={styles.visualMock__barWrapper}>
            <div className={styles.visualMock__bar} style={{ width: '80%' }}></div>
          </div>
          <div className={styles.visualMock__barWrapper}>
            <div className={styles.visualMock__bar} style={{ width: '45%' }}></div>
          </div>
          <div className={styles.visualMock__barWrapper}>
            <div className={styles.visualMock__bar} style={{ width: '60%' }}></div>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: '02',
    title: 'Ставьте финансовые цели',
    desc: 'Создавайте цели для накоплений и отслеживайте прогресс. Приложение показывает, сколько уже накоплено и сколько осталось до результата.',
    visual: (
      <div className={styles.visualMock}>
        <div className={styles.visualMock__circleWrapper}>
          <svg viewBox="0 0 36 36" className={styles.visualMock__circle}>
            <path
              className={styles.visualMock__circleBg}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className={styles.visualMock__circleProgress}
              strokeDasharray="75, 100"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <div className={styles.visualMock__circleText}>75%</div>
        </div>
      </div>
    ),
  },
  {
    id: '03',
    title: 'Анализируйте свои финансы',
    desc: 'Смотрите наглядную аналитику по доходам и расходам. Графики и отчёты помогают понять финансовую картину и принимать более осознанные решения.',
    visual: (
      <div className={styles.visualMock}>
        <div className={styles.visualMock__chart}>
          <div className={styles.visualMock__chartCol} style={{ height: '40%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '70%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '50%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '90%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '30%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '60%' }}></div>
          <div className={styles.visualMock__chartCol} style={{ height: '40%' }}></div>
        </div>
      </div>
    ),
  },
];

const HowItWorks = () => {
  const [activeStep, setActiveStep] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const { top, height } = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (top <= 0 && -top < height - windowHeight) {
        const scrollProgress = -top / (height - windowHeight);
        
        let currentStep = Math.floor(scrollProgress * stepsData.length);
        
        if (currentStep >= stepsData.length) {
          currentStep = stepsData.length - 1;
        }

        if (currentStep !== activeStep) {
          setActiveStep(currentStep);
        }
      } else if (top > 0) {
         setActiveStep(0);
      } else {
         setActiveStep(stepsData.length - 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); 
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeStep]);

  return (
    <section id="how-it-works" className={styles.howItWorks} ref={sectionRef}>
      <div className={styles.stickyContainer}>
        <div className={styles.howItWorks__container}>
          <h2 className={styles.howItWorks__title}>Как это работает</h2>

          <div className={styles.howItWorks__grid}>
            <div className={styles.stepper}>
              {stepsData.map((step, index) => {
                const isActive = index === activeStep;
                
                return (
                  <div
                    key={step.id}
                    className={`${styles.stepperItem} ${isActive ? styles.stepperItemActive : ''}`}
                  >
                    <div className={styles.stepperItem__line}></div>
                    <div className={styles.stepperItem__content}>
                      <div className={styles.stepperItem__num}>{step.id}</div>
                      <h3 className={styles.stepperItem__title}>{step.title}</h3>
                      <p className={styles.stepperItem__desc}>{step.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={styles.visualContainer}>
              <div key={activeStep} className={styles.visualWrapper}>
                {stepsData[activeStep].visual}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;